import React, { useState } from "react";
import { Box, CssBaseline, Grid } from "@mui/material";
import { Button, Typography } from "@mui/material";
import logoImage from "../../assets/images/logoblue.png";
import { CodeForgotPassword } from "../../authentication/components/components";
import { useAuth } from "../../hooks/useAuth";
import { sendgridEmail } from "../../modules/AreaManagement/hooks/AreaHook";
import { getAdminByEmail } from "../../modules/Admins/hooks/AdminsHook";
import {
  getAuth,
  sendPasswordResetEmail,
  signInWithEmailAndPassword,
} from "firebase/auth";

function ForgotPassword() {
  const { forgotPassword } = useAuth();
  const [email, setEmail] = useState("");
  const [showDigitCodePassword, setShowDigitCodePassword] = useState(false);
  const auth = getAuth();

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (email == "") {
      alert("Please input email before proceeding");
      return false;
    }
    let response = await getAdminByEmail(email);
    if (!response) {
      alert("Email address does not exist.");
      return false;
    }

    // User exists, send password reset email
    sendPasswordResetEmail(auth, email)
      .then(() => {
        alert("Check your email for further instructions.");
        // setShowDigitCodePassword(true);
      })
      .catch((error) => {
        console.error(error);
        alert("Failed to send password reset email. Please try again.");
      });

    // let name = email;
    // let code = Math.random() * 900000;
    // code = Math.floor(code) + 100000;
    // let text = `Your verification code to reset your password is ${code}`;
    // const message = {
    //   to: email,
    //   from: process.env.REACT_APP_FROM_EMAIL,
    //   subject: "Reset Password",
    //   html: `
    //   <p><strong>Hi</strong> ${name}</p>
    //   <p>${text}</p>
    //   `,
    // };
    // let responseTemp = await sendgridEmail(message);
    //
  };

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CssBaseline />
        {showDigitCodePassword ? (
          <CodeForgotPassword />
        ) : (
          <Grid
            container
            direction="column"
            alignItems="center"
            spacing={2}
            maxWidth="336px"
          >
            <Grid item>
              <img
                src={logoImage}
                alt="Logo"
                style={{ width: "335.99px", height: "86px", color: "#00A7CD" }}
              />
            </Grid>

            <Grid
              item
              display={"flex"}
              flexDirection="column"
              gap={"4px"}
              spacing={2}
              width="100%"
            >
              <Typography variant="h6" fontWeight={700}>
                Forgot Password
              </Typography>
              <Typography
                fontSize={"14px"}
                fontWeight={500}
                lineHeight={"20px"}
              >
                Enter the e-mail associated with your account and we’ll send a
                verification code to your registered e-mail account.
              </Typography>
              <Typography>E-mail</Typography>
              <input
                type="text"
                value={email}
                //   label="Email"
                //   variant="outlined"
                name="email"
                onChange={handleEmailChange}
                placeholder="Enter your email"
                style={{
                  width: "100%",
                  height: "48px",
                  borderRadius: "8px",
                  border: "1px solid #00A7CD",
                  padding: "12px",
                }}
              />
            </Grid>

            <Grid item width={"336px"} paddingTop={"24px"}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleSubmit}
                style={{
                  width: "100%",
                  height: "34px",
                  borderRadius: "4px",
                  backgroundColor: "#00A7CD",
                }}
              >
                Continue
              </Button>
            </Grid>
          </Grid>
        )}
      </Box>
    </Box>
  );
}

export default ForgotPassword;
